export default __webpack_public_path__ + "static/media/icon-pause.ec2073f9.svg";